import React from 'react'
import './style.scss'

export default function Card(props) { 
    return (
        <div className="card"> 
            <div className="container-img">
                {/* <div className="test-img"></div> */}
                <img height="80%" alt="img" src={props.img} />
            </div>
            <div className="container-texts">
                <div className="title">
                    {props.title}
                </div>
                <div className="description calibri">
                    {props.description}
                </div>
            </div>
        </div>
    )
}